import { DialogDescription } from '@radix-ui/react-dialog';
import { Button } from '../Button';
import { Dialog, DialogClose, DialogContent, DialogFooter, DialogHeader, DialogTitle } from '../Dialog';

export interface ConfirmDiscardDialogProps {
  open: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

export const DiscardChangesDialog = ({ open, onConfirm, onCancel }: ConfirmDiscardDialogProps) => {
  return (
    <Dialog open={open}>
      <DialogContent data-testid="confirm-discard-dialog" showCloseButton={false}>
        <DialogHeader>
          <DialogTitle>Discard Changes</DialogTitle>
          <DialogDescription>Are you sure you want to discard your changes?</DialogDescription>
        </DialogHeader>

        <DialogFooter>
          <Button variant="accent" onClick={onConfirm} data-testid="confirm-discard-button">
            Discard
          </Button>

          <DialogClose asChild>
            <Button variant="transparent" onClick={onCancel}>
              Cancel
            </Button>
          </DialogClose>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
